interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1).filter((item) => {
    return item === 1 || item === totalPages || Math.abs(item - page) <= 1;
  });

  return (
    <nav aria-label="分页导航" className="flex items-center justify-center gap-2 mt-10">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className={`h-9 px-3 rounded-md border text-sm flex items-center gap-1 whitespace-nowrap transition-colors ${
          page === 1
            ? "border-background-200 text-foreground-400 cursor-not-allowed"
            : "border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-400 cursor-pointer"
        }`}
      >
        <i className="ri-arrow-left-s-line text-base" aria-hidden="true"></i>
        上一页
      </button>

      <div className="flex items-center gap-1.5">
        {pages.map((item, index) => {
          const previous = pages[index - 1];
          const showGap = previous && item - previous > 1;
          return (
            <span key={item} className="flex items-center gap-1.5">
              {showGap && <span className="text-foreground-500 px-1 text-sm">…</span>}
              <button
                type="button"
                onClick={() => onChange(item)}
                aria-current={item === page ? "page" : undefined}
                className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
                  item === page
                    ? "bg-primary-500 text-background-50 font-medium"
                    : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-400"
                }`}
              >
                {item}
              </button>
            </span>
          );
        })}
      </div>

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className={`h-9 px-3 rounded-md border text-sm flex items-center gap-1 whitespace-nowrap transition-colors ${
          page === totalPages
            ? "border-background-200 text-foreground-400 cursor-not-allowed"
            : "border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-400 cursor-pointer"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
      </button>
    </nav>
  );
}